import React from 'react';

import cx from 'classnames';

import { useLandingV2Context } from '../../../../../context';
import { ELandingDeviceType } from '../../../../../types';
import s from './index.module.css';
import { ITravelBriefNavigation } from './types';

export const TravelBriefNavigation = ({ eventsType, activeType, onChangeType }: ITravelBriefNavigation) => {
  const withNavigation = eventsType.length > 1;
  const { deviceType } = useLandingV2Context();

  return (
    <>
      {withNavigation && (
        <div className={s.navigationContainer}>
          {eventsType.map((event) => {
            const isActiveType = event.label === activeType;
            return (
              <div
                key={event.label}
                className={cx(
                  s.navigationEvent,
                  eventsType.length === 2 && s.updatedNavigationEvent,
                  isActiveType && s.activeType,
                )}
                onClick={(e) => onChangeType(event.label, e)}
              >
                <div className={s.navigationIcon}>{event.icon}</div>{' '}
                <div className={s.navigationName} data-block>
                  {deviceType === ELandingDeviceType.Desktop || isActiveType ? event.name : null}
                </div>
              </div>
            );
          })}
        </div>
      )}
      {deviceType === ELandingDeviceType.Desktop && (
        <div className={cx(s.whiteBox, !withNavigation && s.updatedWhiteBox)} />
      )}
    </>
  );
};
